import React, { useEffect } from "react";
import { getPermissions } from "../rbac/hasAccess";
import { useNavigate, useParams } from "react-router-dom";
import CommonForm from "../../utils/commonComponent/commonForm";
import Text from "../../utils/commonComponent/Custom/text";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { CancelButton, SaveAndUpdate} from "../../utils/commonComponent/Custom/Button";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { toast } from "react-toastify";

const EditRemark = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const inputFields = [
    { type: "TextField", label: "Remark Label *", stateKey: "label" },
    { type: "Textarea", label: "Description *", stateKey: "value" },
  ];

  const fetchRemarks = async () => {
    try {
      const [remarks] = await fetchQuery(
        `select * from remarks where id = ${params.id}`
      );
      setInputStates(remarks);
    } catch (error) {
      console.error("Error fetching remarks:", error);
    }
  };

  const onSubmit = async () => {
    // show alert
    const fieldsToValidate = [
      { value: inputStates.label, label: "Label is reuqired" },
      { value: inputStates.value, label: "Description is required" },
    ];
    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }
    try {
      const url = BASE_URL + `remarks`;
      const { id, ...payload } = inputStates;
      params.id != 0
        ? await axiosWithToken.patch(url + `/${params.id}`, payload)
        : await axiosWithToken.post(url, payload);

      toast.success(
        params.id !== "0"
          ? "Remark Updated Successfully!"
          : "Remark Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/remarkList"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) {
      fetchRemarks();
    }
  }, [params]);

  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Reamrk" : "Update Reamrk"}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
        colSpan={[1, 4]}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={"Save"}
            onClick={onSubmit}
          />
        )}
      </div>
    </>
  );
};

export default EditRemark;
